import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Card from 'reactstrap/lib/Card';
import CardImg from 'reactstrap/lib/CardImg';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { CORE_SRP_URL_PATTERN } from 'site-modules/shared/constants/inventory/srp-url-patterns';
import { NO_VEHICLE_GRAY_IMAGE_SEDAN } from 'site-modules/shared/constants/images';
import { getDealsUrl } from 'site-modules/shared/utils/core-link-constructor';
import { getDefaultStockPhotoBySize, getStaticImageUrl, SOURCES } from 'client/utils/image-helpers';
import { srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';
import { Image } from 'site-modules/shared/components/image/image';
import { Link } from 'site-modules/shared/components/link/link';

export function ModelsGridSection({ heading, iconClassName = null, models }) {
  return (
    <div className="models-grid-section">
      <h2 className="heading-3 mb-1_5">
        {!!iconClassName && <i className={classnames('text-turquoise-10 me-0_5', iconClassName)} />}
        {heading}
      </h2>
      {!models.length && <Fragment>No incentives available at this time</Fragment>}
      {!!models.length && (
        <Row className="models-grid list-unstyled" tag="ul">
          {models.map(({ year, makeName, modelName, makeSlug, modelSlug }) => {
            const makeModelYear = `${makeName} ${modelName} ${year}`;
            const dealsUrl = getDealsUrl({ makeSlug, modelSlug, year });
            const imageId = getDefaultStockPhotoBySize({ make: makeSlug, model: modelSlug, year }, 300, 200);

            return (
              <Col tag="li" xs={6} md={4} key={`${year}-${modelName}`} className="mb-1 mb-md-1_5">
                <Card className="model-card h-100">
                  <Link
                    className="incentives-link text-primary-darker d-flex flex-column h-100"
                    to={dealsUrl}
                    data-tracking-id="mmy_select"
                    data-tracking-value={makeModelYear}
                  >
                    <div className="img-wrapper">
                      <CardImg
                        tag={Image}
                        errorImage={getStaticImageUrl(NO_VEHICLE_GRAY_IMAGE_SEDAN)}
                        imageId={imageId}
                        source={SOURCES.MEDIA}
                        alt={makeModelYear}
                        className="w-100"
                        top
                      />
                    </div>
                    <h3 className="heading-5 pt-0_5 px-0_75 px-md-1 mb-0_25 mb-md-1">
                      {year} {makeName} {modelName}
                    </h3>
                    <div className="view-incentives px-0_75 px-md-1 mt-auto">
                      View Incentives
                      <span className="icon-arrow-right4 xsmall ms-0_25" aria-hidden />
                    </div>
                  </Link>
                  <hr className="my-0_5 w-100" />
                  <Link
                    to={srpLinkBuilder({
                      inventorytype: 'new',
                      make: makeSlug,
                      model: modelSlug,
                      year,
                      initialUrlPattern: CORE_SRP_URL_PATTERN,
                    })}
                    className="flex-no-shrink d-block text-primary-darker px-0_75 px-md-1 pb-0_5"
                    data-tracking-id="view_search_result"
                    rel="nofollow"
                  >
                    See All for Sale
                    <span className="icon-arrow-right4 xsmall ms-0_25" aria-hidden />
                  </Link>
                </Card>
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
}

ModelsGridSection.propTypes = {
  heading: PropTypes.string.isRequired,
  models: VehicleEntities.ModelYearsByMakeId.isRequired,
  iconClassName: PropTypes.string,
};
